import { CounterPill, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import ContentConstants from '../../../contentConstants';
import { ISummaryItem, ISummaryMessage } from '../../../models';
import {
	ClearDiv,
	Col3Col9,
	ColFull,
	FormattedTable,
	FormattedTableRow,
	FormattedTBodyContainer,
	FormattedTd,
	NoValue,
	SurveyAudienceSummaryItem,
} from '../../common';
import { AudienceDuplicatesPullout } from '../survey-admin/audience/AudienceDuplicatesPullout';

export type SurveyAudiencesLayoutProps = { surveyId: number } & ISummaryItem;

export class SurveyAudiencesLayout extends React.Component<SurveyAudiencesLayoutProps> {
	public render() {
		const { displayName, surveyId, errors } = this.props;
		const summaryItems = this.props.value as { [audienceId: number]: ISummaryItem[] };
		const count = _.keys(summaryItems).length;

		return (
			<ColFull>
				<ClearDiv clearHeight='60px' />
				<AudienceDuplicatesPullout />
				<Col3Col9 label={displayName} labelSize='lg' subLabelDisplayData={<CounterPill actualCount={count} />}>
					{errors && errors.length > 0 && (
						<>
							<Pullout type={PulloutType.Warning}>
								<p>
									<strong>{ContentConstants.ERROR_CAPS}:</strong> {ContentConstants.AUDIENCE_PUBLISH_GENERICERROR}
								</p>
								{errors.map((m: ISummaryMessage, key: any) => (
									<p key={key}>{m.message}</p>
								))}
							</Pullout>
							<ClearDiv clearHeight='30px' />
						</>
					)}
					{_.map(summaryItems, (items: ISummaryItem[], audienceIdString: string) => {
						const audienceId = parseInt(audienceIdString, 10);
						return (
							<FormattedTable key={audienceId} paddingLeft={0}>
								<FormattedTBodyContainer>
									<FormattedTableRow>
										<FormattedTd flexBasis={100}>
											<SurveyAudienceSummaryItem surveyId={surveyId} audienceId={audienceId} summaryItems={items} />
										</FormattedTd>
									</FormattedTableRow>
								</FormattedTBodyContainer>
							</FormattedTable>
						);
					})}
					{count === 0 && NoValue}
					{count === 0 && <ClearDiv clearHeight='60px' />}
					{count > 0 && <ClearDiv clearHeight='30px' />}
				</Col3Col9>
			</ColFull>
		);
	}
}
